import React, { Suspense, useEffect, useState } from 'react';
import { Seo } from 'src/public/components/Seo';
import { App } from 'src/app/App';
import { useStorePageUrl } from 'src/common/hooks/useStorePageUrl';
import styled from 'styled-components';

const HeroPlaceholder = styled.div`
  width: 100%;
  height: 100vh;
  background: #2a2b32;
`;

const IndexPage = () => {
  useStorePageUrl();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      <Seo />
      {isClient ? (
        <Suspense fallback={<HeroPlaceholder />}>
          <App />
        </Suspense>
      ) : (
        <HeroPlaceholder />
      )}
    </>
  );
};
// eslint-disable-next-line import/no-default-export
export default IndexPage;
